/* eslint-disable import/prefer-default-export */
enum inputValues {
    default = 0,
    subscription = 1
}

export { inputValues };
